import React from "react";
import { DividedBlade, EDividedBladeDirection } from "@organic-return/foundation-react/src/components/Blades/DividedBlade";

const DividedBladeContentLong = ({ module }) => {
  //get module fields
  const { customFields } = module;

  let contentDirection;
  if (customFields?.direction == "column") {
    contentDirection = EDividedBladeDirection.column;
  }
  else {
    contentDirection = EDividedBladeDirection.row;
  }

  const link = customFields.link &&
  {
    label: customFields.link.text,
    url: customFields.link.href,
  }

  let contentCols: string[] = [];
  customFields.secondSectionColumnOne && contentCols.push(customFields.secondSectionColumnOne);
  customFields.secondSectionColumnTwo && contentCols.push(customFields.secondSectionColumnTwo);
  customFields.secondSectionColumnThree && contentCols.push(customFields.secondSectionColumnThree);

  return (
    <div className="divided-blade-long inverted">
      <DividedBlade
        direction={contentDirection}
        firstSection={{
          header: customFields?.title,
          titleHeadingLevel: customFields?.headingLevel,
          text: customFields?.firstSectionText,
        }}
        secondSection={{
          header: customFields?.secondSectionText,
          contentCols: contentCols,
          link: link,
        }}
        className="max-w-screen-2xl mx-auto"
      ></DividedBlade>
    </div>
  )
}

export default DividedBladeContentLong;